import { TOGGLE_MODAL } from 'redux/actionTypes/modalActionTypes';
import {
  SIGN_UP_MODAL,
  LOGIN_MODAL,
  SOCIAL_MODAL,
  MOBILE_SOCIAL_MODAL,
  EDIT_ABOUT_MODAL,
  SEND_TICKETS_MODAL,
  END_POOL_MODAL,
  JOIN_POOL_MODAL,
  REDEEM_MODAL,
  EDIT_TOKENS_MODAL,
  CREATE_HPOOL_SIGN_TX_MODAL,
  USER_REDEEM_HPOOL_TOKENS_MODAL,
  HORD_SUPPORTED_TOKENS_MODAL,
  MANUAL_ORDERS_MODAL,
} from '../../components/Modals/modalTypes';

/**
 * Dispatches action to toggle modal.
 *
 * @param {String} modalType
 * @param {Object} modalProps
 * @param {Boolean} action - to close or to open
 */
export const toggleModal = (modalType, modalProps, action, extraInfo) => (dispatch) => {
  dispatch({
    type: TOGGLE_MODAL,
    payload: { modalType, modalProps, action, ...extraInfo },
  });
};

/**
 * Closes the modal that is currently open
 */
export const closeModal = () => (dispatch) => {
  dispatch({
    type: TOGGLE_MODAL,
    payload: { modalType: '', modalProps: {}, action: false },
  });
};

export const openSignUpModal = () => async (dispatch) => {
  const modalProps = { className: 'form-action-modal', width: 440 };
  dispatch(toggleModal(SIGN_UP_MODAL, modalProps, true));
};

export const openLoginModal = () => async (dispatch) => {
  const modalProps = { className: 'form-action-modal', width: 440 };
  dispatch(toggleModal(LOGIN_MODAL, modalProps, true));
};

export const openSocialModal = () => async (dispatch) => {
  const modalProps = { className: 'form-action-modal', width: 440 };
  dispatch(toggleModal(SOCIAL_MODAL, modalProps, true));
};

export const openMobileSocialModal = (socials) => async (dispatch) => {
  const modalProps = { className: 'form-action-modal', width: 440, socials };
  dispatch(toggleModal(MOBILE_SOCIAL_MODAL, modalProps, true));
};

export const openEditAboutModal = () => async (dispatch) => {
  const modalProps = { className: 'form-action-modal', width: 440 };
  dispatch(toggleModal(EDIT_ABOUT_MODAL, modalProps, true));
};

export const openSupportedTokensModal = () => async (dispatch) => {
  const modalProps = { className: 'form-action-modal', width: 800 };
  dispatch(toggleModal(HORD_SUPPORTED_TOKENS_MODAL, modalProps, true));
};

export const openSendTicketsModal = () => async (dispatch) => {
  const modalProps = { className: 'form-action-modal', width: 440 };
  dispatch(toggleModal(SEND_TICKETS_MODAL, modalProps, true));
};

export const openEndPoolModal = () => async (dispatch) => {
  const modalProps = { className: 'form-action-modal', width: 440 };
  dispatch(toggleModal(END_POOL_MODAL, modalProps, true));
};

export const openJoinPoolModal =
  (extraInfo = {}) =>
  async (dispatch) => {
    const modalProps = { className: 'form-action-modal', width: 440 };
    dispatch(toggleModal(JOIN_POOL_MODAL, modalProps, true, extraInfo));
  };

export const openRedeemModal = () => async (dispatch) => {
  const modalProps = { className: 'form-action-modal', width: 440 };
  dispatch(toggleModal(REDEEM_MODAL, modalProps, true));
};

export const openUserRedeemHPoolTokensModal = () => async (dispatch) => {
  const modalProps = { className: 'form-action-modal', width: 440 };
  dispatch(toggleModal(USER_REDEEM_HPOOL_TOKENS_MODAL, modalProps, true));
};

export const openEditTokensModal =
  (additionalProps = {}) =>
  async (dispatch) => {
    const modalProps = { className: 'form-action-modal', width: 850, ...additionalProps };
    dispatch(toggleModal(EDIT_TOKENS_MODAL, modalProps, true));
  };
export const openManualOrdersModal =
  (additionalProps = {}) =>
  async (dispatch) => {
    const modalProps = { className: 'form-action-modal', width: 850, ...additionalProps };
    dispatch(toggleModal(MANUAL_ORDERS_MODAL, modalProps, true));
  };

export const openCreateHPoolSignTxModal = () => async (dispatch) => {
  const modalProps = { className: 'form-action-modal', width: 850 };
  dispatch(toggleModal(CREATE_HPOOL_SIGN_TX_MODAL, modalProps, true));
};

export const openModal =
  (modal, extraProps = {}) =>
  async (dispatch) => {
    const defaultModalProps = { className: 'form-action-modal', width: 440, ...extraProps };
    dispatch(toggleModal(modal, defaultModalProps, true));
  };
